import { SelectOption } from "./app/common/select/select-option-type";

export const DEFAULT_DELAY: number = 100;

export const DEFAULT_MODAL_STYLE = {
    modal: {
        enter: 'enter-scale-down 0.1s ease-out',
    },
    overlay: {
        leave: 'fade-out 0.3s',
    }
};

export const MIN_WIN_WIDTH = 1800;
export const MINUTE_IN_MS = 60000;

// Auto-confirm timer constants
export const MODAL_AUTO_CONFIRM_TIMEOUT_MS = 10000; // 10 seconds
export const PROGRESS_BAR_UPDATE_INTERVAL_MS = 50; // Update every 50ms
